  (() => {
  const formatWithDelimiter = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (Number.isNaN(number) || number == null) return '0';
    const parts = (number / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
  };

  const formatMoney = (cents, format) => {
    const template = format || '${{amount}}';
    const match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return `$${formatWithDelimiter(cents)}`;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiter(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiter(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiter(cents, 0, '.', ',');
        break;
      case 'amount':
      default:
        value = formatWithDelimiter(cents, 2);
        break;
    }
    return template.replace(match[0], value);
  };

  const initializeOffer = (root) => {
    if (root.dataset.euInitialized === 'true') return;
    root.dataset.euInitialized = 'true';

    const variantInput = root.querySelector('[data-eu-variant-input]');
    const quantityInput = root.querySelector('[data-eu-quantity-input]');
    const choices = Array.from(root.querySelectorAll('[data-eu-pack-choice]'));
    const addButton = root.querySelector('[data-eu-add-button]');
    const addLabel = root.querySelector('[data-eu-add-label]');
    const sticky = root.querySelector('[data-eu-mobile-buy]');
    const stickyButton = root.querySelector('[data-eu-sticky-button]');
    const moneyFormat = root.dataset.moneyFormat;
    const shopPrefix = root.dataset.shopPrefix || 'Shop';
    const soldLabel = root.dataset.soldLabel || 'Sold Out';

    if (!variantInput || !quantityInput || !choices.length) return;

    const summaryLabel = root.querySelector('[data-eu-summary-label]');
    const summarySupply = root.querySelector('[data-eu-summary-supply]');
    const summaryRetail = root.querySelector('[data-eu-summary-retail]');
    const summarySaveRow = root.querySelector('[data-eu-summary-save-row]');
    const summarySave = root.querySelector('[data-eu-summary-save]');
    const summaryTotal = root.querySelector('[data-eu-summary-total]');
    const summaryEffective = root.querySelector('[data-eu-summary-effective]');
    const stickyLabel = root.querySelector('[data-eu-sticky-label]');
    const stickySummary = root.querySelector('[data-eu-sticky-summary]');

    const activeChoice = () =>
      choices.find((choice) => choice.getAttribute('aria-pressed') === 'true') || choices[0];

    const update = () => {
      const choice = activeChoice();
      if (!choice) return;

      const price = Number(choice.dataset.price || 0);
      const compare = Number(choice.dataset.compare || 0);
      const bottles = Number(choice.dataset.bottles || 1);
      const servings = Number(choice.dataset.servings || 0);
      const label = choice.dataset.label || '';
      const available = !choice.disabled;

      variantInput.value = choice.dataset.variantId;
      quantityInput.value = choice.dataset.cartQuantity || '1';

      if (summaryLabel) summaryLabel.textContent = label;
      if (summarySupply) summarySupply.textContent = `${servings} servings | ${bottles} bottle${bottles !== 1 ? 's' : ''}`;
      if (summaryRetail) summaryRetail.innerHTML = formatMoney(compare > price ? compare : price, moneyFormat);

      if (compare > price) {
        if (summarySaveRow) summarySaveRow.style.display = '';
        if (summarySave) summarySave.innerHTML = formatMoney(compare - price, moneyFormat);
      } else if (summarySaveRow) {
        summarySaveRow.style.display = 'none';
      }

      if (summaryTotal) summaryTotal.innerHTML = formatMoney(price, moneyFormat);
      if (summaryEffective) {
        const perBottle = Math.round(price / bottles);
        summaryEffective.innerHTML = `${formatMoney(perBottle, moneyFormat)} per bottle`;
      }

      if (stickyLabel) stickyLabel.textContent = label;
      if (stickySummary) stickySummary.innerHTML = formatMoney(price, moneyFormat);

      addButton.disabled = !available;
      addLabel.textContent = available ? `${shopPrefix} ${label}`.trim() : soldLabel;
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        if (choice.disabled) return;
        choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
        update();
      });
    });

    stickyButton?.addEventListener('click', () => {
      root.querySelector('.eu-product-form')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    const toggleSticky = () => {
      if (!sticky) return;
      const offerTop = root.getBoundingClientRect().top + window.scrollY;
      sticky.classList.toggle('is-visible', window.scrollY > Math.max(720, offerTop - window.innerHeight));
    };

    window.addEventListener('scroll', toggleSticky, { passive: true });
    window.addEventListener('resize', toggleSticky);
    update();
    toggleSticky();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-eu-offer]').forEach(initializeOffer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
